import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import { Flipper, Front } from '../Flipper';
import globe from 'images/globe.svg';

export const MapTab = ({ handleSelect, className, ...props }) => (
  <li className={classNames('Instrument MapTab', className)}>
    <Flipper flipped={false}>
      <Front>
        <button onClick={handleSelect} role="navigation">
          <h3>Kart</h3>
          <div className="icon-wrapper">
            <img alt="" src={globe} aria-hidden="true" />
          </div>
        </button>
      </Front>
    </Flipper>
  </li>
);

MapTab.propTypes = {
  handleSelect: PropTypes.func,
};

export default MapTab;
